import styled from 'styled-components';

import type { Hue } from '@/types/styles';

import { colors } from '@/styles/colors';
import { DEFAULT_CONTRACT_COLOR } from '@/config/variables';

const ColoredEllipse = styled.div<{ lineColor?: Hue }>`
  margin-right: 5px;
  width: 5px;
  height: 5px;
  border: ${({ lineColor }) => `5px solid ${colors[lineColor || DEFAULT_CONTRACT_COLOR].c500}`};
  border-radius: 100%;
`;

export { ColoredEllipse };
